import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export const usePriceOverrideApplyBtnEffect = ({
    isPriceOverride,
    priceOverrideTableData,
    setFooterButtonStatuses,
    footerButtonStatuses,
    cancel,
    isPriceOverrideApplyBtnDisabled,
    priceOverrideReason,
    pricingNotes,
    priceOverrideReasonVisibilityUsage,
    priceOverrideReasonMandatoryUsage,
    priceOverrideCommentsVisibilityUsage,
    priceOverrideCommentsMandatoryUsage,
}) => {
    useEffectWithErrorLogging(() => {
        if (isPriceOverride && priceOverrideTableData.length > 0) {
            setFooterButtonStatuses(
                footerButtonStatuses.map((x) =>
                    x.btnName !== cancel && x.btnVisibility
                        ? {
                              ...x,
                              isBtnDisable: isPriceOverrideApplyBtnDisabled(
                                  priceOverrideReason,
                                  priceOverrideTableData,
                                  pricingNotes,                                  
                                  priceOverrideReasonMandatoryUsage,  
                                  priceOverrideReasonVisibilityUsage ,                              
                                  priceOverrideCommentsMandatoryUsage,
                                  priceOverrideCommentsVisibilityUsage
                              ),
                          }
                        : x
                )
            );
        }
    }, [priceOverrideReason, priceOverrideTableData, pricingNotes]);
};
